import RegionLayoutBasic from "@/views/layouts/RegionLayoutBasic.vue";
import Login from "@/views/auth/Login.vue";
import RegionLoginLayout from "@/views/layouts/RegionLoginLayout.vue";
import MainPage from "@/views/regions/MainPage.vue";

const routes = [
  {
    path: '/r/a',
    component: RegionLoginLayout,
    name: 'RegionLogin',
  },
  {
    path: '/r',
    component: RegionLayoutBasic,
    meta: {requiresAuth: true},
    children: [
      {
        path: '/',
        component: MainPage,
        name: 'RegionMainPage',
        meta: {},
      },
      // {
      //   path: 'login',
      //   component: Login,
      //   name: 'RegionLogin',
      //   meta: {
      //     // allowedTo: [ROLES.ID.SuperAdmin],
      //     // permission: 'region/login'
      //   }
      // },
    ]
  }
];

export default routes;
